<template>
    <form class="paginator" action="javascript:;" @submit="submitPage" v-if="total_page > 1">
        <a href="javascript:;" @click="decreasePage">&lt;</a>
        <span>{{ page }}/{{ total_page }}</span>
        <a href="javascript:;" @click="increasePage">&gt;</a>
        <input type="number" name="page">
        <button class="a-button--primary" type="submit">跳转</button>
    </form>
</template>
<script>
const PER = 20
export default {
    computed: {
        total_page () {
            const per = this.per || PER
            return Math.ceil(this.total_count / per)
        }
    },
    methods: {
        submitPage (e) {
            const page = Number(e.target.page.value.trim())
            if (page > 0 && page <= this.total_page) {
                this.$emit('changePage', page)
            }
        },
        decreasePage () {
            if (this.page > 1) {
                this.$emit('changePage', this.page - 1)
            }
        },
        increasePage () {
            if (this.page < this.total_page) {
                this.$emit('changePage', this.page + 1)
            }
        }
    },
    props: {
        total_count: {
            type: Number,
            default: 0
        },
        page: {
            type: Number,
            default: 1
        }
    }
}
</script>
<style lang="scss" scoped>
.paginator {
    width: 300px;
    margin: 20px auto;
    font-size: 14px;
    display: flex;
    align-items: center;
    a, button {
        display: inline-block;
        width: 32px;
        height: 32px;
        line-height: 32px;
        color: #fff;
        background-color: #00AD83;
        text-align: center;
        text-decoration: none;
        border-radius: 3px;
        cursor: pointer;
    }
    span {
        margin: 0 6px;
    }
    input {
        width: 32px;
        height: 32px;
        border-radius: 3px;
        border: 1px solid #00AD83;
        padding: .2em;
        text-align: center;
        margin: 0 5px;
    }
    button {
        width: 60px;
        line-height: 30px;
        outline: 0;
    }
}
</style>
